import React from "react";
import {connect} from "react-redux";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import DirtyModal from "../common/DirtyModal";
import ErrorModal from "../common/ErrorModal";
import LoginSignupModal from "./LoginSignupModal";
import ClientViewPort from "../common/ClientViewPort";
import StoreHomeScreen from '../store/StoreHomeScreen';
import JoinHomeScreen from '../join/JoinHomeScreen';
import AccountHomeScreen from '../account/AccountHomeScreen';
import PayHomeScreen from '../pay/PayHomeScreen';
import {URLs} from "../../common/constants";
import {checkVersion} from "../../actions/common/commonActions";

class HomeScreen extends React.Component {
    componentWillMount() {
        window.onbeforeunload =  function () {
            if (this.props.isChanged && !this.props.isPreview)
                return '';
        }.bind(this);
        this.props.checkVersion();
    }

    getScreen = () => {
        switch (this.props.screen) {
            case URLs.STORE :
                return (<StoreHomeScreen location={this.props.location}/>);
            case URLs.JOIN:
                return (<JoinHomeScreen location={this.props.location}/>);
            case URLs.ACCOUNT:
                return (<AccountHomeScreen location={this.props.location}/>);
            case URLs.PAY:
            case URLs.CHARGE:
                return (<PayHomeScreen location={this.props.location}/>);
        }
    };

    render() {
		return (
			<div>
				<Header clientViewPort={this.props.clientViewPort} staticData={this.props.staticData}/>
				<div className={"main-container" + (this.props.showCustomFooter ? " include-custom-footer" : "")}>
					{this.getScreen()}
				</div>
                <Footer clientViewPort={this.props.clientViewPort} staticData={this.props.staticData}/>
                <LoginSignupModal/>
                <DirtyModal/>
                <ErrorModal/>
                <ClientViewPort/>
            </div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
    const screen = ownProps.location.pathname.split("/")[1];
    return {
        staticData: state.staticData,
        clientViewPort: (state.clientViewPort || {}),
        screen: screen,
        isChanged: (state.orderStatus || {}).isChanged,
        isPreview: (state.staticData || {}).isPreview,
        showCustomFooter: state.staticData.customFooterHTML && state.staticData.customFooterHTML !== ''
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkVersion: () => {
            dispatch(checkVersion());
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);


// WEBPACK FOOTER //
// ./src/containers/common/HomeScreen.js